/**
 * 七日签到 — 接口数据映射
 * 对应 Apifox：/cycleSign/getInfo、/cycleSign/sign
 */

import { locale } from '@/utils/i18n'

/** 轮次状态枚举 */
export const CYCLE_SIGN_STATUS = {
  SIGNING: 1, // 签到中
  LOCKED: 2, // 锁定待解锁充值
}

/** 解锁订单 — 支付成功状态码 */
export const UNLOCK_ORDER_SUCCESS_STATUS = ['01', '1', 1]

/** 解锁订单 — 支付失败状态码 */
export const UNLOCK_ORDER_FAILED_STATUS = ['02', '04', '05', '2', 2, 4, 5]

/** 将 daily_rewards 数组映射为 UI 列表项 */
export const mapDailyRewards = (dailyRewards = [], signCount = 0) => {
  if (!Array.isArray(dailyRewards) || !dailyRewards.length) return []

  return dailyRewards.map((amount, index) => ({
    day: index + 1, // 第几天
    amount: Number(amount) || 0, // 当日奖励金额
    collected: index + 1 <= signCount, // 是否已领取
  }))
}

/** 将 getInfo / sign 接口 data 映射为组件状态 */
export const mapCheckInInfo = (raw = {}) => {
  const signCount = Number(raw.sign_count ?? 0) // 本轮已签次数
  const status = Number(raw.status ?? 0) // 轮次状态
  const dailyRewards = mapDailyRewards(raw.daily_rewards, signCount)

  // return testCheckInInfo(dailyRewards)

  return {
    enabled: raw.enabled === 1, // 活动是否开启
    status, // 轮次状态码
    statusText: raw.status_text ?? '', // 状态文案 signing / locked
    cycleNo: Number(raw.cycle_no ?? 1), // 当前第几轮
    signCount, // 已签到次数 0~7
    piggyAmount: Number(raw.piggy_amount ?? 0), // 储蓄罐暂存金额
    totalReward: Number(raw.total_reward ?? 0), // 满签可释放总额
    todaySigned: raw.today_signed === 1, // 今日是否已签
    unlockRechargeAmount: Number(raw.unlock_recharge_amount ?? 0), // 解锁所需充值金额
    dailyRewards, // 7 天奖励列表
    unlockOrderNo: raw.unlock_order_no ?? '', // 绑定解锁订单号
    unlockOrderStatus: raw.unlock_order_status ?? null, // 绑定订单充值状态
    isLocked: status === CYCLE_SIGN_STATUS.LOCKED, // 是否锁定待充值
    // 今日是否可签到
    canSignToday:
      raw.enabled === 1 &&
      status === CYCLE_SIGN_STATUS.SIGNING &&
      raw.today_signed !== 1 &&
      signCount < dailyRewards.length,
  }
}

export const testCheckInInfo = (dailyRewards) => {
  return {
    enabled: 1, // 活动是否开启
    status: CYCLE_SIGN_STATUS.SIGNING, // 轮次状态码
    statusText: 'signing', // 状态文案 signing / locked
    cycleNo: 0, // 当前第几轮
    signCount: 4, // 已签到次数 0~7
    piggyAmount: 0, // 储蓄罐暂存金额
    totalReward: 0, // 满签可释放总额
    todaySigned: true, // 今日是否已签
    unlockRechargeAmount: 0, // 解锁所需充值金额
    dailyRewards, // 7 天奖励列表
    unlockOrderNo: '', // 绑定解锁订单号
    unlockOrderStatus: null, // 绑定订单充值状态
    isLocked: false, // 是否锁定待充值
    canSignToday: true, // 今日是否可签到
  }
}

/** 判断解锁订单是否支付成功 */
export const isUnlockOrderSuccess = (status) => UNLOCK_ORDER_SUCCESS_STATUS.includes(status)

/** 判断解锁订单是否支付失败 */
export const isUnlockOrderFailed = (status) => UNLOCK_ORDER_FAILED_STATUS.includes(status)

/** 创建默认空状态 */
export const createDefaultCheckInState = () => mapCheckInInfo({})

/** 按当前 locale 格式化金额：6 -> "6,00" / "6.00" */
export const formatBonus = (value) => {
  const currentLocale = locale.value || 'pt-BR'
  return new Intl.NumberFormat(currentLocale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value) || 0)
}
